import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BannersService {
  constructor(private readonly http: HttpClient) {}

  getAllBanners(params: any): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/admin/banners', { params });
  }

  getBannersById(id: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`/v1/admin/banners/${id}`);
  }

  editBanner(id: string, bannerData: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/banners/${id}`, bannerData);
  }

  deleteBanner(id: string): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`/v1/admin/banners/${id}`);
  }

  createBanner(bannerData: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`/v1/admin/banners`, bannerData);
  }

  changeSequence(data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/banners/updateSequence/`, { data });
  }
}
